const flexContainer = (direction = 'row') =>
  `display: flex;flex-direction: ${direction};`;

const Flex = {
  row: flexContainer('row'),
  column: flexContainer('column'),
  center: `align-items: center;justify-content: center;`,
};

export default Flex;
